import { useEffect, useMemo } from 'react'

import { UseFormReturn } from 'react-hook-form'

import { UserNotificationsForm_JobSearchPreferenceFragment } from '@gql/graphql'

import { TJobSearchPreferencesForm } from '@/forms/types'

interface IUseJobSearchPreferencesResetFormParams {
  form: UseFormReturn<TJobSearchPreferencesForm>
  jobSearchPreference?: UserNotificationsForm_JobSearchPreferenceFragment | null
}

export const useJobSearchPreferencesReset = ({
  form,
  jobSearchPreference,
}: IUseJobSearchPreferencesResetFormParams) => {
  const jobSearchPreferenceValues = useMemo(() => {
    const cleanedPreferences = jobSearchPreference
      ? Object.fromEntries(
          Object.entries({
            companyNumEmployeesMax: jobSearchPreference.companyNumEmployeesMax,
            companyNumEmployeesMin: jobSearchPreference.companyNumEmployeesMin,
            datePosted: jobSearchPreference.datePosted,
            educationRequirement: jobSearchPreference.educationRequirement,
            employmentTypes: jobSearchPreference.employmentTypes,
            experienceLevels: jobSearchPreference.experienceLevels,
            keywords: jobSearchPreference.keywords,
            locations: jobSearchPreference.locations,
            payPeriod: jobSearchPreference.payPeriod,
            positions: jobSearchPreference.positions,
            salaryMin: jobSearchPreference.salaryMin,
            visaSponsorship: jobSearchPreference.visaSponsorship,
            workArrangements: jobSearchPreference.workArrangements,
          }).filter(
            ([, value]) =>
              value !== undefined &&
              value !== null &&
              (Array.isArray(value) ? value.length > 0 : true)
          )
        )
      : undefined

    return {
      jobSearchPreferences:
        cleanedPreferences && Object.keys(cleanedPreferences).length > 0
          ? cleanedPreferences
          : undefined,
    }
  }, [jobSearchPreference])

  useEffect(() => {
    form.reset({
      ...form.formState.defaultValues,
      jobSearchPreferences: jobSearchPreferenceValues.jobSearchPreferences,
    })
  }, [jobSearchPreferenceValues, form, jobSearchPreference])
}
